import { render } from "./NavSubsection.vue?vue&type=template&id=2c394584&ts=true"
import script from "./NavSubsection.vue?vue&type=script&lang=ts"
export * from "./NavSubsection.vue?vue&type=script&lang=ts"

import "./NavSubsection.vue?vue&type=style&index=0&id=2c394584&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__